import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { CURRENT_USERS } from './constants';
import {
  CurrentUsersSuccess,
  CurrentUsersError,
  CurrentUsersDataActionTypes,
  CurrentUsersState,
} from './types';

const initialState: CurrentUsersState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: CurrentUsersDataActionTypes,
  ): CurrentUsersState => {
    switch (action.type) {
      case CURRENT_USERS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case CURRENT_USERS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as CurrentUsersSuccess).payload;
        break;
      }
      case CURRENT_USERS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as CurrentUsersError).error;
        break;
      }
      default:
        return draft;
    }
  },
);
